import QueryString from 'query-string'

const getReturnUrl = () => {
  return QueryString.parse(window.location.search).returnUrl
}

const getUser = () => {
  return QueryString.parse(window.location.search).user
}

export  {
  getReturnUrl,
  getUser
}


// WEBPACK FOOTER //
// ./src/utils/queryParams.js